import { commonUtils } from '@/helpers/commonUtils'
import { BaseVm } from '@/mobxTools'
import { buyVipService } from '@/services/buyVipService'
import { userService } from '@/services/userService'
import { debounce } from 'lodash'
import { observable } from 'mobx'
import { BuyTokenPackageDialogProps } from '.'

export class BuyTokenPackageDialogVm extends BaseVm<BuyTokenPackageDialogProps> {
  props!: BuyTokenPackageDialogProps
  @observable selectPlan!: ServerDataTypes.PackagePlan
  @observable packagePlans: ServerDataTypes.PackagePlan[] = []

  @observable currentTabKey: 'wx_pub_qr' | 'alipay_qr' = 'alipay_qr'
  @observable orderCreating = true
  @observable orderQrCode = ''
  @observable qrErr = false
  @observable packageCount = 1

  private sessionId?: string
  private timer?: NodeJS.Timeout
  private currentOrderId?: string // 添加当前订单ID追踪

  public debounceGenOrderQrCode = debounce(() => {
    this.handlePriceChange()
  }, 300)

  public onViewCreate(): void {
    this.initPlansData()
    // userService.trackUserRecord('buyVipDialogV1_token')
  }
  public onViewDestroy(): void {
    // view 被销毁后执行
    this.clearTimeout()
  }

  public async genOrderQrCode() {
    if (!userService.isLogin) {
      console.error('未找到用户登录态')
      return
    }
    this.orderCreating = true
    this.qrErr = false
    const sessionId = commonUtils.genId()
    this.sessionId = sessionId

    // 清除上一次的轮询和订单ID
    this.clearTimeout()
    this.currentOrderId = undefined

    try {
      const { qr, orderId } = await buyVipService.createPackageOrder({
        action: userService.userData?.versionData.version === 'free' ? 'buy' : 'renew',
        chargeChannel: this.currentTabKey,
        planId: this.selectPlan.id,
        version: 'pro',
        source: `${this.props.source}`,
        count: this.packageCount,
      })

      // 检查sessionId是否还有效
      if (this.sessionId !== sessionId) {
        return
      }

      this.orderQrCode = qr
      this.currentOrderId = orderId
      this.pollingOrderStatus(orderId, sessionId, true)
    } catch (error) {
      console.log(error)
      this.qrErr = true
    }
    this.orderCreating = false
  }

  handlePriceChange(): void {
    this.genOrderQrCode()
  }

  private async initPlansData() {
    try {
      const { dataList } = await buyVipService.getPackageList()

      this.packagePlans = dataList

      if (!dataList.length) {
        this.props.onClose?.(false)
        return
      }

      this.selectPlan = dataList.find((item) => item.packetScene === this.props.type)! || dataList[0]
      this.genOrderQrCode()

    } catch (error) {
      console.error('获取套餐列表失败')
    }
  }
  private async pollingOrderStatus(orderId: string, sessionId: string, force = false, cnt = 0) {
    // 检查对话框是否仍然打开
    if (!this.props.open) {
      return
    }

    // 检查sessionId是否还有效（防止过期的轮询继续执行）
    if (this.sessionId !== sessionId) {
      return
    }

    // 检查是否是当前的订单ID
    if (this.currentOrderId !== orderId) {
      return
    }

    if (force) {
      try {
        const { status } = await buyVipService.pollOrderStatus(orderId)

        // 再次检查sessionId，防止在异步请求过程中状态变化
        if (this.sessionId !== sessionId || this.currentOrderId !== orderId) {
          return
        }

        if (status === 'completed') {
          try {
            commonUtils.sendExtensionMessage('markPaid', {})
          } catch (error) { }
          if (this.props.paySuccess) {
            this.props.paySuccess()
          }
          setTimeout(() => {
            if (this.props.onClose) {
              this.props.onClose(true)
            }
          })
          /** 停止轮询,给出成功提示 */
          this.clearTimeout()
          return
        }

        if (status === 'canceled' || status === 'refunded') {
          /** 停止轮询 */
          return
        }

        if (status === 'created') {
          this.timer = setTimeout(() => {
            this.pollingOrderStatus(orderId, sessionId, true, 0)
          }, 1000)
        }
      } catch (error) {
        if (cnt > 5) {
          this.clearTimeout()
          this.qrErr = true
          /** 重试结束，停止轮询 */
          return
        }
        // 继续重试时也要传递sessionId
        this.pollingOrderStatus(orderId, sessionId, true, cnt + 1)
      }
    }
  }

  private clearTimeout() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = undefined
    }
  }
}
